import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Helpers from '@/lib/helpers';

interface ExpandableTextProps {
  text: React.ReactNode;
  limit?: number;
  className?: string;
  buttonClassName?: string;
  'data-testid'?: string;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  limit = 180,
  className = '',
  buttonClassName = '',
  'data-testid': dataTestId = 'expandable-text',
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (text == null || text === '') return null;

  const wrapClass = cn('min-w-0 max-w-full break-all', className);

  const isString = typeof text === 'string';
  const shouldTruncate = isString && (text as string).length > limit;

  if (!shouldTruncate) {
    return (
      <div className={wrapClass} data-testid={dataTestId}>
        {text}
      </div>
    );
  }

  const toggleExpand = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={wrapClass} data-testid={dataTestId}>
      {isExpanded ? text : Helpers.truncateText(text as string, limit)}
      <button
        type="button"
        onClick={toggleExpand}
        className={`text-light-text-secondary dark:text-dark-text-secondary hover:text-light-primary dark:hover:text-dark-primary font-medium ml-1 transition-colors ${buttonClassName}`}
        data-testid={`${dataTestId}-toggle`}
      >
        {isExpanded ? t('showLess') : t('showMore')}
      </button>
    </div>
  );
};

export default ExpandableText;
